import type { IShapeOfField } from "@/utils/zod";
import { z } from "@/utils/zod";
import type { IPhoneNumber } from "@/interfaces";
import { EmptyPhoneNumber } from "@constants";

export interface IStudentForgetPasswordFormSchema {
  phoneNumber: IPhoneNumber;
}

export const studentForgetPasswordFormInitialValues: IStudentForgetPasswordFormSchema =
  {
    phoneNumber: EmptyPhoneNumber,
  };

export const studentForgetPasswordFormValidationSchema = z.object<
  IShapeOfField<IStudentForgetPasswordFormSchema>
>({
  phoneNumber: z.phone(),
});
